import { Component, Input, OnInit } from '@angular/core';
import type { ChartConfiguration, ChartOptions } from 'chart.js/auto';

@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    standalone: false
})
export class ChartComponent implements OnInit {

  @Input() title: string = '';
  @Input() labels: string[] = [];
  @Input() values: number[] = [];

  public barChartType: ChartConfiguration<'bar'>['type'] = 'bar';

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: []
  };

  public barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: 10
    },
    plugins: {
      legend: {
        labels: {
          padding: 20
        }
      }
    },
    indexAxis: 'y', // 👈 THIS replaces 'horizontalBar'
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 1
        }
      }
    }
  };

  public barChartPlugins = [];

  constructor() { }

  ngOnInit(): void {
    let height = this.labels.length * 30;
    if (height < 200) height = 200;

    const container = document.getElementById('chartContainer');
    if (container) {
      container.style.height = height + 'px';
    }

    const backgroundColors: string[] = [];

    for (let i = 0; i < this.values.length; i++) {
      backgroundColors.push(i % 2 === 0 ? '#0275d8' : '#5bc0de');
    }

    this.barChartData = {
      labels: this.labels,
      datasets: [
        {
          data: this.values,
          label: this.title,
          backgroundColor: backgroundColors
        }
      ]
    };
  }
}